export enum ProductSize {
	Xs = "Xs",
	S = "S",
	M = "M",
	L = "L",
}
